import React, {
useEffect,
useRef,
useState,
useMemo,
useCallback,
Component,
forwardRef,
useImperativeHandle
} from "react";
import { useDispatch, useSelector } from "react-redux";
import {
getAllMarketDataIndices,
getMarketDataDetails,
} from "../../../../../actions/marketDataAction";
import { SBAComboBox } from "../../../../../UiComponents/SBADropDown";
import { BreadCrumbs } from "../../../../../shared/breadCrumbs/BreadCrumbs";
import { useNavigate, useParams,Link } from "react-router-dom";
import { LoadingScreen } from "../../../../../UiComponents/LoadingComponent";
import axios from "axios";
import moment from "moment";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { UrlPath } from "../../../../../../config/routeConfig";
import { TopBar } from "../../../../../shared/topBar/TopBar";
import { AgGridReact } from "ag-grid-react";
import { getAssetValuation } from "../../../../../actions/postReturnsAction";
import { insertUpdateAssetValuation, DeleteAssetValuation, updateImportReturns,DownloadImportMarketIndexTemplate } from "../../../../../../config/apiConfig";
import { ToastContainer, toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { sbaAxios } from "../../../../../utils/sbaAxios";
import * as XLSX from 'xlsx';
import { SBNotify } from "../../../../../utils/sbNotify";
import { SBADrawer } from "../../../../../UiComponents/SBADrawer";
import { AssetDropDown } from "../../../../../UiComponents/AssetDropDown";
import { SBDatePicker } from "../../../../../UiComponents/SBDatePicker";

export const MarketAnalyticsPostPricing = () => {
const emptyImportReturns = {
    selectedFile: null,
    FundLots: false,
    ExistingData: false,
    FinalReturns: false,
}
// const Gstate = useSelector((state) => state) || {};
const [Loading, setLoading] = useState(true);
const [render, setRender] = useState(true);
const gridRef = useRef();
const [buttonGo, setbuttonGo] = useState(true);
const [isChecked, setIsChecked] = useState(true);
const [selectedLotListButton, setLotListButton] = useState(3);
const [selectedDate, setSelectedDate] = useState(new Date());
const [selectedFrequencyId, setSelectedFrequencyId] = useState(3);
const [rorValuationId, setRorValuationId] = useState();
const [navValuationId, setNavValuationId] = useState();
const [showModal, setShowModal] = useState(false);
const [gridData, setGridData] = useState([]);
const [updateGridData, setUpdateGridData] = useState(0);
const [importReturnsDrawer, setImportReturns] = useState(false);
const [drawerData, setDrawerData] = useState(emptyImportReturns);
const [workbookFile, setWorkbookFile] = useState(null);

let saveDataLV=[];


const params = useParams();
const history = useNavigate();
const dispatch = useDispatch();

    



const Gstate =
useSelector((state) => {
    return state;
}) || {};
const AssetListDDL = Gstate.assetDDL.assetList || [];
const currentAsset = Gstate.asset.asset || {};
useEffect(()=>{
    if(updateGridData!==0)
    dispatch(
    getAssetValuation(
        3,
        params.MarketIndexId,
        selectedFrequencyId,
        selectedDate.toISOString()
    )
    )
},[updateGridData])
const marketlistdata = Gstate.Marketdata?.Indices || [];
const marketdatadetails = Gstate.Marketdata?.Marketdatadetails || {};

useEffect(() => {
marketdatadetails && marketlistdata && setLoading(false);
}, [Gstate]);

useEffect(() => {
document.title = `Analytics Reporting`;
dispatch(getMarketDataDetails(params.MarketIndexId));
dispatch(getAllMarketDataIndices());
}, [render]);

//button trigger here for initial load

useEffect(() => {
enterButtonClick();
}, []);

const AssestDDChanged = (e) => {
e.value
    ? history(`${UrlPath.MarketAnalyticsPostPricing}${e.value.MarketIndexId}`)
    : history(`${UrlPath.MarketAnalyticsPostPricing}${params.MarketIndexId}`);
setRender(!render);
};

const handleDateChange = (e) => {};

const handleCheckboxChange = () => {
setIsChecked(!isChecked);
};

const lotSeriesColumnDefs = [
{ headerName: "Lot Series Name", field: "" },
{ headerName: "Date", field: "" },
];

//Clear All
const clearButtonClick = (e) => {};

const enterButtonClick = () => {
dispatch(
    getAssetValuation(
    3,
    params.MarketIndexId,
    selectedFrequencyId,
    selectedDate.toISOString()
    )
);
};


const benchmarkingPerfButtonClick = (index) => {
setLotListButton(index);
const selectedButtonId = buttonIds[index];
setSelectedFrequencyId(selectedButtonId);
dispatch(
    getAssetValuation(
    3,
    params.MarketIndexId,
    selectedButtonId,
    selectedDate.toISOString()
    )
);
};

const DeleteButtonRenderer = (props) => {
const Id = props.data;

const handleDeleteClick = () => {
    setShowModal(true);
    setRorValuationId(Id.RorValuationId);
    setNavValuationId(Id.NavValuationId);
};

return (
    <div className="actions-cell">
    <i
        className="fas fa-trash"
        style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
        onClick={handleDeleteClick}
    ></i>
    </div>
);
};

const closeModal = () => {
setShowModal(false);
}

const onDeleteButtonClick = () => {
    setShowModal(false);
    sbaAxios({
        url: `${DeleteAssetValuation}?rorValuationId=${rorValuationId}&navValuationId=${navValuationId}`
    }).then((response) => {
        if (response === -4444 || response === -3333) {
            closeModal();
            toast.error("Delete Failed", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            closeModal();
            toast.success("Return Delete Successfully", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            setTimeout(() => {
                enterButtonClick();
            }, 100);
        }
    })
        .catch((error) => {
            console.error("Error deleting data:", error);
        });
};

const buttonNames = ["1D", "1W", "Mid-Month", "1M", "Qtr"];
const buttonIds = ["1", "2", "15", "3", "4"];

const LotListButtons = buttonNames.map((name, index) => (
<button
    key={index}
    id={`button-${buttonIds[index]}`}
    className={`non-gappable-button ${
    selectedLotListButton === index ? "selected-non-gappable-button" : ""
    }`}
    onClick={() => benchmarkingPerfButtonClick(index)}
>
    {name}
</button>
));

const assetValuationData = Gstate?.PostReturns?.assetValuationData || [];

useEffect(()=>{
setGridData([...assetValuationData]);
},[assetValuationData])

const formatDate = (params) => {
const dateValue = params.value;
if (dateValue) {
    return moment(dateValue).format("MM/DD/YYYY");
}
else{
    return 'Invaild Date'
}
};

const formatNumber = (params) => {
const numberValue = params.value;
if (typeof numberValue === "number") {
    return new Intl.NumberFormat().format(numberValue);
}
return;
};

const formatDecimal = (params) => {
const decimalValue = params.value;
if (typeof decimalValue === "number") {
    return new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    }).format(decimalValue);
}
return;
};


const listofDetailsColumnDefs = [
{
    headerName: 'Row ID',
    valueGetter: 'node.id',
    hide:true
},
        
{
    headerName: "Date",
    field: "ValuationDate",
    valueFormatter: formatDate,
    editable: false,
},
{
    headerName: "Price Date",
    field: "ValuationDate",
    valueFormatter: formatDate,
    editable: false,
},
{
    headerName: "Net Asset Value ($US)",
    field: "NavValue",
    valueFormatter: formatNumber,
},
{
    headerName: "Return (%)",
    field: "RorValue",
    valueFormatter: params => {
        if (params && params.value !== undefined && params.value !== null) {
            const rawValue = params.value > 999 ? 999 : params.value;
            const formattedValue = parseFloat(rawValue).toFixed(2); // Adjust 2 to the desired number of decimal places
            return formattedValue;
        } else {
            // Handle the case where params or params.value is null or undefined
            return null; // or a default value or an empty string, depending on your requirements
        }
    },
    //valueFormatter: formatDecimal,
    //cellEditor:ReturnCellEditor
},
{
    headerName: "Date Received",
    field: "ModifiedDate",
    cellRenderer:formatDate,
    cellEditor: DateEditor,
    editable: true,
},
{
    headerName: "Action",
    field: "Action",
    maxWidth: 100,
    cellRenderer: DeleteButtonRenderer,
    editable: false,
    filter: false,
},
];

const defaultColDef = useMemo(() => {
return {
    flex: 1,
    editable: true,
    cellDataType: false,
    sortable: false,
    filter: true,
    suppressMovable: true,
    floatingFilter: true,
    singleClickEdit: true,
    resizable:true
};
}, []);
const onCellValueChanged = async (e) => {
try {
    const updatedData = [...saveDataLV];
    const rowIndex = updatedData.findIndex((item) => item.rowIndex === e.rowIndex
    );
    if (rowIndex < 0) {
        const newData = {
            rowIndex: e.rowIndex,
            ...e.data
        };
        updatedData.push(newData);
    } else {
    updatedData[rowIndex] = e.data;
    }
    saveDataLV=updatedData;
} catch (error) {
    console.error("Error while saving data:", error);
}
};

const saveButtonClick = async () => {
await gridRef.current.api.stopEditing(); 
setTimeout(() => {   
    saveRequest(saveDataLV);   
    }, 500);
};

const saveandCloseButtonClick = async () => {
await gridRef.current.api.stopEditing();  
setTimeout(() => {    
    saveRequest(saveDataLV);  
    cancelButtonClick();
}, 500);
};

const saveRequest=(data)=>{
let saveSuccess=true;
const processedData = data.map(item => {
    return {
    "rorValuationId": item.RorValuationId,
    "navValuationId": item.NavValuationId,
    "entityTypeId": 3,
    "entityId": item.EntityId,
    "entityName": item.EntityName,
    "frequencyId": selectedFrequencyId,
    "valuationDate": item.ValuationDate,
    "rorValue": parseFloat(item.RorValue),
    "navValue": parseFloat(item.NavValue),
    "estimateActual": item.EstimateActual,
    "modifiedBy": 0,
    "modifiedByName": item.ModifiedByName,
    "modifiedDate": (item.ModifiedDate)
    }
});
processedData.map(async (item) => {
    const response = await sbaAxios({ url: insertUpdateAssetValuation, method: 'post', data: item }).then(response=>{
    saveSuccess=true
    }).catch(()=>{
    saveSuccess=false
    });
})

if(saveSuccess){
    toast.success('Data saved successfully', {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: "light",
})   
}
else{
    toast.error('error saving data', {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: "light",
})
}
setUpdateGridData(value=>value+1);
saveDataLV=[];
};

const importReturnsClick = () => {
    setImportReturns(true);
};

const handleFileChange = (event) => {
    const { name } = event.target;
    const file = event.target.files[0];
    const updatedState = { ...drawerData, [name]: file };
    setDrawerData(updatedState);

    if (file) {
        const reader = new FileReader();
        reader.onload = (event) => {
            const fileContent = event.target.result;

            const workbook = XLSX.read(fileContent, { type: 'binary' ,cellDates: true});
            setWorkbookFile(workbookToSheetsArray(workbook));
        };

        reader.readAsBinaryString(file);
    }
};

const workbookToSheetsArray = (workbook) => {
    const sheetsArray = [];
    workbook.SheetNames.forEach((sheetName) => {
        const sheet = workbook.Sheets[sheetName];
        const table = XLSX.utils.sheet_to_json(sheet, { header: 1 });
        const formattedTable = formatTableWithNulls(table);
        sheetsArray.push({ name: sheetName, table: formattedTable });
    });
    return sheetsArray;
};

const formatTableWithNulls = (table) => {
    const headers = table[0];

    if (!validateHeaders(headers)) {
        return [];
    }

    return table.slice(1).map((row) => {
        const isRowEmpty = row.every((value) => value === undefined || value === null);
        if (isRowEmpty) {
            return null;
        }
        const formattedRow = {};
        headers.forEach((header, index) => {
            if (header === 'PriceDate') {
                const formattedDate = row[index];
                formattedRow[header] = formatExcelDate?formatExcelDate(formattedDate):null;
            } else {
                formattedRow[header] = row[index] === undefined ? null : row[index];
            }
        });
        return formattedRow;
    }).filter((row) => row !== null);
};

const formatExcelDate = (inputDate) => {
       
    const date = new Date(inputDate);
    const month = date.getMonth() + 1; 
    const day = date.getDate();
    const year = date.getFullYear();
    const formattedMonth = month < 10 ? '0' + month : month;
    const formattedDay = day < 10 ? '0' + day : day;
    const formattedDate = `${formattedMonth}/${formattedDay}/${year}`;

    return formattedDate;
};

const validateHeaders = (headers) => {
    const requiredHeaders = ["AssetId", "EntityTypeId", "PriceDate", "NAV", "Ror", "EstimatedActual"];

    const missingHeaders = requiredHeaders.filter(header => !headers.includes(header));
    if (missingHeaders.length > 0) {
        return false;
    }
    return true;
};

const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    const value = checked ? true : false;
    const updatedState = { ...drawerData, [name]: value };
    setDrawerData(updatedState);
};

const saveImportReturns = async () => {
    let saveSuccess = true;
    let saveMsg="Invalid File Format";
    const mappedData = workbookFile[0].table.map((row) => {
        if(row.EntityTypeId!==3 || row.AssetId!==parseInt(params.MarketIndexId))
        {
            saveSuccess=false;
            saveMsg='Please Import Returns Data for the Selected Account';
        }
        return{
        EntityId: row.AssetId,
        EntityTypeId: row.EntityTypeId,
        ValuationDate: row.PriceDate
            ? moment(row.PriceDate).format("MM/DD/yyyy")
            : null,
        NAV: row.NAV,
        RoR: Number(parseFloat(row.Ror).toFixed(4)),
        ActualEstimate: row.EstimatedActual
    }});

    const data = {
        mappedData
    };
    
    if (
        data.mappedData.length === 0 || data.mappedData === "") {
        saveSuccess = false;
    };

    if (saveSuccess) {
        const response = await sbaAxios({
            url: `${updateImportReturns}`,
            method: "post",
            data: mappedData,
        });
        if (response > 0) {
            setImportReturns(false);
            dispatch(
              getAssetValuation(
                3,
                params.MarketIndexId,
                selectedFrequencyId,
                selectedDate.toISOString()
              )
            );
            SBNotify({ type: "success", Msg: "Import Successfully" });
        } else {
            SBNotify({ type: "warning", Msg: "Failed" });
        }
    }
    else {
        SBNotify({ type: "error", Msg: saveMsg });
    }
};

const cancelImportReturns = () => {
    setImportReturns(false);
};

const cancelButtonClick = (e) => {
history(`${UrlPath.MarketAnalytics}${params.MarketIndexId}`, { state: { ActiveTab: "AnalyticsandReporting", currentAssetId: params.MarketIndexId } });
};

let Level = [
{
    BreadCrumb: "Analytics and Reporting > ",
    Routes: `${UrlPath.UniverseList}`,
},
];
Level = Loading
? Level
: [
    ...Level,
    {
        BreadCrumb: `Market Data >`,
        Routes: `${UrlPath.MarketData}`,
    },
    {
        BreadCrumb: `${marketdatadetails?.MarketIndexName}`,
        Routes: `${UrlPath.MarketAnalyticsPostPricing}${params.MarketIndexId}`,
    },
    ];

const FilterOptions = () => {
    const [dateValue, setDateValue] = useState(selectedDate);
    const postPricingdateChange = (e) => {
        const changedDate = new Date(e);
          
        setDateValue(changedDate);
    };
const enterClick = () => {
    setSelectedDate(dateValue)
    dispatch(
        getAssetValuation(
        3,
        params.MarketIndexId,
        selectedFrequencyId,
        dateValue.toISOString()
        )
    );
    };
    //const gridOptions = {
    //    onFirstDataRendered: (params) => {
    //        // Select the first row by default
    //        params.api.forEachNode((node, index) => {
    //            if (index === 0) {
    //                node.setSelected(true);
    //            }
    //        });
    //    },
    //};
    const rowDataUpdated = (params) => {
        params.api.forEachNode((node, index) => {
            if (index === 0) {
                node.setSelected(true);
            }
        });
    }
      

return (
    <>
    <div className="performance bg-white m-3 p-border rounded">
        <div className="justify-content-between p-3">
        <div className="analytics-selection bg-white p-4">
            <div className="row gap-3">
            <div className="col-md-3 col-lg-3">
                <label htmlFor="select fund" className="mb-1 label">
                Select Index
                </label>
                <div className="DropDownDiv input-border">
                <SBAComboBox
                    data={marketlistdata}
                    textField={"MarketIndexName"}
                    valueField={"MarketIndexId"}
                    value={marketdatadetails}
                    onChange={AssestDDChanged}
                />
                </div>
            </div>
            <div className="col-md-3 col-lg-3">
                <label htmlFor="select fund" className="mb-1 label">
                List(Series)Name
                </label>
                <select
                className="form-select"
                aria-label="Default select example"
                >
                <option selected>Composite</option>
                </select>
            </div>
            <div className="col-md-3 col-lg-3 d-flex date-gap">
                <div className="col-md-12 col-lg-12 example-wrapper">
                <label className="mb-1 label">Select Date</label>
                                <div className="">
                                    <SBDatePicker

                                        value={moment(dateValue)}
                       
                                        onChange={(e) => {
                                            postPricingdateChange(e);
                                        }}
                    />
                </div>
                </div>
            </div>
            </div>
            <br></br>
            <div>
            <label className="d-flex">
                <input
                type="checkbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
                />
                <span style={{ marginLeft: "10px" }}>
                Hide series/lots with 0 positions
                </span>
            </label>
            </div>
            {!isChecked && (
            <>
                <hr />
                <br></br>
                <div
                className="ag-theme-alpine"
                style={{ height: 200, width: 600 }}
                >
                                <AgGridReact
                                    columnDefs={lotSeriesColumnDefs} defaultColDef={{resizable:true}}
                                    />
                </div>
            </>
            )}
            <div className="mt-3">
            {/* <button
                type="button"
                className="cancel-btn"
                onClick={clearButtonClick}
            >
                Clear All
            </button> */}
            <button
                type="button"
                className="p-sm-btn ms-2"
                onClick={enterClick}
            >
                Enter
            </button>
            </div>
        </div>
        </div>
    </div>

    <div className="header-container m-3">
        <b> List of Details </b>
            <div className="button-container">
                <button
                    style={{ marginRight: "10px" }}
                    className="ms-2 p-sm-btn"
                    onClick={importReturnsClick}
                >
                    Import Returns
                </button>
                {LotListButtons}
            </div>
    </div>
    <div className="m-3">
        <div className="ag-theme-alpine" style={{ height: 420 }}>
        <AgGridReact
            columnDefs={listofDetailsColumnDefs}
            rowData={gridData}
            defaultColDef={defaultColDef}
            onCellValueChanged={onCellValueChanged}
                    ref={gridRef}
                    onRowDataUpdated={rowDataUpdated}
                    
        />
        </div>
    </div>
    <div className="m-3 d-flex justify-content-end">
        <button
        type="button"
        className="s-sm-btn"
        onClick={cancelButtonClick}
        >
        Cancel
        </button>
        <button
        type="button"
        className="p-sm-btn ms-2"
        onClick={saveButtonClick}
        >
        Save
        </button>
        <button
        type="button"
        className="p-sm-btn ms-2"
        onClick={saveandCloseButtonClick}
        >
        Save & Close
        </button>
    </div>
    </>
);
};
const DownloadFile=()=>
{
  sbaAxios({
    url: DownloadImportMarketIndexTemplate ,
    responseType: 'blob'
}).then((response) => {
    var downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(response);
    downloadLink.download = "MarketIndexImport.xlsx";
    downloadLink.click();   
});

}
return (
<>
    <div id="PostReturnsDiv">
    {Loading ? (
        <>
        <LoadingScreen />
        </>
    ) : (
        <>
        <TopBar label={"Post Returns"} />
        <div>
            <div id="content" className="analytics mainContentData">
            <BreadCrumbs Levels={Level} />
            <FilterOptions />
            </div>
        </div>

        { <Modal show={showModal}  >
            <Modal.Header closeButton onClick={closeModal}>
                <Modal.Title>Do you want to delete the selected Return?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>The selected Return will be deleted permanently. Are you sure?</p>
            </Modal.Body>
            <Modal.Footer>
                <button className="s-sm-btn mx-1" onClick={closeModal} > Cancel</button>
                <button className='p-sm-btn mx-1' onClick={onDeleteButtonClick} >
                    Yes
        </button>
            </Modal.Footer>
        </Modal> }
                        <SBADrawer
                            open={importReturnsDrawer}
                            setOpen={setImportReturns}
                            close={false}
                            title={`Import Returns`}
                            size={"50rem"}
                        >
                            <div>
                                <div className="col-lg-12 row m-0 mb-4 gap-2">
                                    <div className="col-md-6">
                                        <div className="mb-4">
                                            <span className="fw-medium">Select Index</span>
                                            <SBAComboBox
                                                data={marketlistdata}
                                                textField={"MarketIndexName"}
                                                valueField={"MarketIndexId"}
                                                value={marketdatadetails}
                                                onChange={AssestDDChanged}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-4">
                                            <span className="fw-medium">
                                                download fund names/symbols file
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-4">
                                            <span className="fw-medium">Select File</span>
                                            <input type="file" accept=".xls,.xlsx" name="selectedFile" onChange={handleFileChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-4">
                                        <span className="fw-medium">
                                        <Link onClick={DownloadFile}> Download returns import file</Link>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-12 row m-0 mb-4 gap-2">
                                    {/* <div className="col-md-6">
                                        <div className="d-flex align-items-center mb-2">
                                            <input
                                                type="checkbox"
                                                name="FundLots"
                                                checked={drawerData.FundLots === true}
                                                onChange={handleCheckbox}
                                            />
                                            <label className="ms-2">Apply to fund lots</label>
                                        </div>
                                        <div className="d-flex align-items-center mb-2">
                                            <input
                                                type="checkbox"
                                                name="ExistingData"
                                                checked={drawerData.ExistingData === true}
                                                onChange={handleCheckbox}
                                            />
                                            <label className="ms-2">Override existing data</label>
                                        </div>
                                        <div className="d-flex align-items-center mb-2">
                                            <input
                                                type="checkbox"
                                                name="FinalReturns"
                                                checked={drawerData.FinalReturns === true}
                                                onChange={handleCheckbox}
                                            />
                                            <label className="ms-2">
                                                Mark month end returns as final
                                            </label>
                                        </div>
                                    </div> */}
                                </div>
                                <div className="mt-4">
                                    <button className="s-sm-btn mx-1" onClick={cancelImportReturns}>Cancel</button>
                                    <button className="p-sm-btn mx-1" onClick={saveImportReturns}>Import</button>
                                </div>
                            </div>
                        </SBADrawer>
        <ToastContainer />
        </>
    )}
    </div>
</>
);
};
class DateEditor extends Component {
constructor(props) {
super(props);
this.state = {
    date: new Date (props.value),
};
}

getValue() {
return this.state.date;
}

afterGuiAttached() {
// Focus on the DatePicker input field after it's attached
this.datePicker.focus();
}

render() {
return (
    <DatePicker
    ref={(el) => (this.datePicker = el)}
    value={this.state.date}
    onChange={(event) => this.setState({ date: event.value })}
    />
);
}
}
export const ReturnCellEditor =forwardRef((props, ref) => {
const [value, setValue] = useState(props.value);
const refInput = useRef(null);
useImperativeHandle(ref, () => ({
getValue() {
    return value > 999 ? 999.00 : value;
},
}));

return (
<input
    ref={refInput}
    type="number"
    style={{width:'100%'}}
    value={value}
    onChange={(event) => setValue(event.target.value)}
/>
);
});